<template>
  <div id="bg" v-loading="listLoading">
    <div class="lke-bg" :style="{ minHeight: minHeight + 'px' }">
      <div class="lke-bg-l">
        <div class="lke-box">
          <div class="lke-l-t">
            <div>{{ userInfo.name }}</div>
            <div>
              <span>准考证号:</span>
              <span v-if="roles === 'notEnrolled'" style="margin-left: 5px">{{
                userInfo.uid
              }}</span>
              <span v-else style="margin-left: 5px">{{ userInfo.sid }}</span>
            </div>
            <div>
              <span>作答时间:</span>
              <span style="margin-left: 5px">{{ paperInfo.time }}分钟</span>
            </div>
          </div>
        </div>
        <div class="lke-box">
          <div class="lke-l-m">
            剩余时间:
            <span>{{ date.h }}</span>
            小时
            <span>{{ date.m }}</span>
            分
            <span>{{ date.s }}</span>
            秒
          </div>
        </div>
        <div class="lke-box">
          <div class="lke-l-f">
            <div class="lke-l-f-title">答题卡</div>
            <div class="lke-l-f-box" v-for="(list, index) in paperList.topic" :key="index">
              <div class="lke-l-f-box-top">
                {{ numIndex[index] }}、{{ list.name }}
              </div>
              <div class="lke-l-f-box-mid" style="display: block" v-if="
                list.subjectType === 'gapFill' ||
                list.subjectType === 'blanksFill'
              ">
                <div class="lke-l-f-box-mid-tab-on" style="align-items: flex-start"
                  v-for="(tab, index2) in list.children" :key="index2">
                  <div>{{ index2 + 1 }}.</div>
                  <div style="
                      display: flex;
                      align-items: center;
                      flex: 1;
                      flex-wrap: wrap;
                    ">
                    <div class="lke-l-f-box-mid-tab" v-for="(cha, index3) in tab.coursesubject.enum" :key="index3">
                      <div @click="gopaper(index + '_' + index2 + '_' + index3)" class="lke-l-f-box-mid-tab-in"
                        :class="{ active: tab.coursesubject.answer[index3] }">
                        {{ index3 + 1 }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="lke-l-f-box-mid" style="display: block" v-else-if="
                list.subjectType === 'composite' ||
                list.subjectType === 'clozeFill' ||
                list.subjectType === 'A3A4'
              ">
                <div class="lke-l-f-box-mid-tab-on" style="align-items: flex-start"
                  v-for="(tab, index2) in list.children" :key="index2">
                  <div>{{ index2 + 1 }}.</div>
                  <div style="
                      display: flex;
                      align-items: center;
                      flex: 1;
                      flex-wrap: wrap;
                    ">
                    <div class="lke-l-f-box-mid-tab" v-for="(children, index3) in tab.coursesubject.children"
                      :key="index3">
                      <div @click="gopaper(index + '_' + index2 + '_' + index3)" class="lke-l-f-box-mid-tab-in"
                        :class="{ active: children.answer[0] }">
                        {{ index3 + 1 }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="lke-l-f-box-mid" v-else>
                <div class="lke-l-f-box-mid-tab" v-for="(tab, index2) in list.children" :key="index2">
                  <div @click="gopaper(index + '_' + index2)" class="lke-l-f-box-mid-tab-in"
                    :class="{ active: tab.coursesubject.answer[0] }">
                    {{ index2 + 1 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lke-bg-r">
        <div class="lke-box">
          <div class="lke-r-t">
            <span>{{ paperInfo.name }}</span>
            <span>总分:{{ paperList.score }}分</span>
          </div>
        </div>
        <div class="lke-box">
          <div v-for="(list, index) in paperList.topic" :key="index">
            <div class="lke-r-title">
              {{ numIndex[index] }}、{{ list.name }}
            </div>
            <!--单项选择题 -->
            <div class="lke-text" v-if="list.subjectType === 'oneChoice'">
              <el-form label-position="left" label-width="20px" v-for="(paper, index2) in list.children" :key="index2"
                :id="index + '_' + index2">
                <div class="lke-text-in">
                  <div class="lke-text-in-span">
                    {{ index2 + 1 }}.{{ paper.coursesubject.subjectName }}
                    <span>({{ paper.score }}分)</span>
                  </div>
                  <el-form-item>
                    <el-radio-group v-model="paper.coursesubject.answer[0]">
                      <div class="lke-xuanze">
                        <el-radio v-for="(tab, index3) in paper.coursesubject.options" :key="index3"
                          :label="xuanziIndex[index3]">{{ xuanziIndex[index3] }}、{{ tab }}</el-radio>
                      </div>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <!--多项选择题 -->
            <div class="lke-text" v-if="list.subjectType === 'nChoice'">
              <el-form label-position="left" label-width="20px" v-for="(paper, index2) in list.children" :key="index2"
                :id="index + '_' + index2">
                <div class="lke-text-in">
                  <div class="lke-text-in-span">
                    {{ index2 + 1 }}.{{ paper.coursesubject.subjectName }}
                    <span>({{ paper.score }}分)</span>
                  </div>
                  <el-form-item>
                    <el-checkbox-group v-model="paper.coursesubject.answer">
                      <div class="lke-xuanze" v-for="(tab, index3) in paper.coursesubject.options">
                        <el-checkbox :key="index3" :label="xuanziIndex[index3]">{{ xuanziIndex[index3] }}、{{ tab
                          }}</el-checkbox>
                      </div>
                    </el-checkbox-group>
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <!--判断题 -->
            <div class="lke-text" v-if="list.subjectType === 'trueOrFalse'">
              <el-form label-position="left" label-width="20px" v-for="(paper, index2) in list.children" :key="index2"
                :id="index + '_' + index2">
                <div class="lke-text-in">
                  <div class="lke-text-in-span">
                    {{ index2 + 1 }}.{{ paper.coursesubject.subjectName }}
                    <span>({{ paper.score }}分)</span>
                  </div>
                  <el-form-item>
                    <el-radio-group v-model="paper.coursesubject.answer[0]">
                      <div class="lke-xuanze">
                        <el-radio label="true">A、正确</el-radio>
                      </div>
                      <div class="lke-xuanze">
                        <el-radio label="false">B、错误</el-radio>
                      </div>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <!--填空题 -->
            <div class="lke-text" v-if="list.subjectType === 'gapFill'">
              <el-form label-position="left" label-width="60px" v-for="(paper, index2) in list.children" :key="index2">
                <div class="lke-text-in">
                  <div class="lke-text-in-span">
                    {{ index2 + 1 }}.{{ paper.coursesubject.subjectName }}
                    <span>({{ paper.score }}分)</span>
                  </div>
                  <el-form-item :id="index + '_' + index2 + '_' + index3" :label="'答案(' + (index3 + 1) + ')'"
                    style="padding-left: 20px" v-for="(tab, index3) in paper.coursesubject.enum" :key="index3">
                    <el-input size="mini" v-model="paper.coursesubject.answer[index3]"></el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <!--选择填空题 -->
            <div class="lke-text" v-if="list.subjectType === 'blanksFill'">
              <el-form label-position="left" label-width="60px" v-for="(paper, index2) in list.children" :key="index2">
                <div class="lke-text-in">
                  <div class="lke-text-in-span">
                    {{ index2 + 1 }}.{{ paper.coursesubject.subjectName }}
                    <span>({{ paper.score }}分)</span>
                  </div>
                  <el-form-item>
                    <div v-for="(tab, index3) in paper.coursesubject.options" :key="index3">
                      {{ xuanziIndex[index3] }}、{{ tab }}
                    </div>
                  </el-form-item>
                </div>
                <el-form-item :id="index + '_' + index2 + '_' + index3" :label="'答案(' + (index3 + 1) + ')'"
                  style="padding-left: 20px" v-for="(tab, index3) in paper.coursesubject.enum" :key="index3">
                  <el-radio-group v-model="paper.coursesubject.answer[index3]">
                    <el-radio v-for="(tab, index4) in paper.coursesubject.options" :key="index4" style="display: inline"
                      :label="xuanziIndex[index4]"></el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>
            <!--简答题 -->
            <div class="lke-text" v-if="list.subjectType === 'shortAnswer'">
              <el-form label-position="left" label-width="60px" v-for="(paper, index2) in list.children" :key="index2"
                :id="index + '_' + index2">
                <div class="lke-text-in">
                  <div class="lke-text-in-span">
                    {{ index2 + 1 }}.{{ paper.coursesubject.subjectName }}
                    <span>({{ paper.score }}分)</span>
                  </div>
                  <el-form-item style="padding-left: 20px; padding-bottom: 10px">
                    <el-upload
                      class="short-answer-upload"
                      :action="uploadAction"
                      :before-upload="beforeDocUpload"
                      :headers="uploadHeaders"
                      :show-file-list="false"
                      :on-success="(res, file) => handleShortAnswerUploadSuccess(res, file, paper)"
                    >
                      <el-button plain size="mini" type="primary">上传Word/PDF</el-button>
                    </el-upload>
                    <div
                      v-if="isFileLink(paper.coursesubject.answer[0])"
                      class="short-answer-upload-tip"
                    >
                      当前附件：
                      <a
                        :href="toFileUrl(paper.coursesubject.answer[0])"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ extractFileName(paper.coursesubject.answer[0]) }}
                      </a>
                    </div>
                  </el-form-item>
                  <el-form-item label="答案" style="padding-left: 20px; padding-bottom: 10px">
                    <el-input size="mini" type="textarea" v-model="paper.coursesubject.answer[0]"></el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <!--复合题 -->
            <div class="lke-text" id="here" v-if="list.subjectType === 'composite'">
              <el-form label-position="left" label-width="20px" v-for="(paper, index2) in list.children" :key="index2"
                :id="index + '_' + index2">
                <div class="lke-text-in">
                  <div class="lke-text-in-span">
                    {{ index2 + 1 }}.{{ paper.coursesubject.subjectName }}
                    <span>({{ paper.score }}分)</span>
                  </div>
                  <div v-for="(children, index3) in paper.coursesubject.children" :key="index3">
                    <div style="padding-left: 20px" v-if="children.subjectType === 'oneChoice'"
                      :id="index + '_' + index2 + '_' + index3">
                      <div class="lke-text-in-span" style="font-weight: normal">
                        ({{ index3 + 1 }}).{{ children.subjectName }}
                      </div>
                      <el-form-item>
                        <el-radio-group v-model="children.answer[0]">
                          <div class="lke-xuanze">
                            <el-radio v-for="(tab, index4) in children.options" :key="index4"
                              :label="xuanziIndex[index4]">{{ xuanziIndex[index4] }}、{{ tab }}</el-radio>
                          </div>
                        </el-radio-group>
                      </el-form-item>
                    </div>
                    <div style="padding-left: 20px" v-if="children.subjectType === 'nChoice'"
                      :id="index + '_' + index2 + '_' + index3">
                      <div class="lke-text-in-span" style="font-weight: normal">
                        ({{ index3 + 1 }}).{{ children.subjectName }}
                      </div>
                      <el-form-item>
                        <el-checkbox-group v-model="children.answer">
                          <div class="lke-xuanze">
                            <el-checkbox v-for="(tab, index4) in children.options" :key="index4"
                              :label="xuanziIndex[index4]">{{ xuanziIndex[index4] }}、{{ tab }}</el-checkbox>
                          </div>
                        </el-checkbox-group>
                      </el-form-item>
                    </div>
                    <div style="padding-left: 20px" v-if="children.subjectType === 'trueOrFalse'"
                      :id="index + '_' + index2 + '_' + index3">
                      <div class="lke-text-in-span" style="font-weight: normal">
                        ({{ index3 + 1 }}).{{ children.subjectName }}
                      </div>
                      <el-form-item>
                        <el-radio-group v-model="children.answer[0]">
                          <div class="lke-xuanze">
                            <el-radio label="true">A、正确</el-radio>
                          </div>
                          <div class="lke-xuanze">
                            <el-radio label="false">B、错误</el-radio>
                          </div>
                        </el-radio-group>
                      </el-form-item>
                    </div>
                  </div>
                </div>
              </el-form>
            </div>
            <div class="lke-text" id="here" v-if="list.subjectType === 'clozeFill'">
              <el-form label-position="left" label-width="35px" v-for="(paper, index2) in list.children" :key="index2"
                :id="index + '_' + index2">
                <div class="lke-text-in">
                  <div class="lke-text-in-span">
                    {{ index2 + 1 }}.{{ paper.coursesubject.subjectName }}
                    <span>({{ paper.score }}分)</span>
                  </div>
                  <div v-for="(children, index3) in paper.coursesubject.children" :key="index3">
                    <div style="padding-left: 20px" v-if="children.subjectType === 'oneChoice'"
                      :id="index + '_' + index2 + '_' + index3">
                      <el-form-item :label="'(' + (index3 + 1) + ').'">
                        <el-radio-group v-model="children.answer[0]">
                          <el-radio style="display: inline" v-for="(tab, index4) in children.options" :key="index4"
                            :label="xuanziIndex[index4]">{{ xuanziIndex[index4] }}、{{ tab }}</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </div>
                  </div>
                </div>
              </el-form>
            </div>
            <div class="lke-text" id="here" v-if="list.subjectType === 'A3A4'">
              <el-form label-position="left" label-width="20px" v-for="(paper, index2) in list.children" :key="index2"
                :id="index + '_' + index2">
                <div class="lke-text-in">
                  <div class="lke-text-in-span">
                    {{ index2 + 1 }}.{{ paper.coursesubject.subjectName }}
                    <span>({{ paper.score }}分)</span>
                  </div>
                  <div v-for="(children, index3) in paper.coursesubject.children" :key="index3">
                    <div style="padding-left: 20px" v-if="children.subjectType === 'oneChoice'"
                      :id="index + '_' + index2 + '_' + index3">
                      <div class="lke-text-in-span" style="font-weight: normal">
                        ({{ index3 + 1 }}).{{ children.subjectName }}
                      </div>
                      <el-form-item>
                        <el-radio-group v-model="children.answer[0]">
                          <div class="lke-xuanze">
                            <el-radio v-for="(tab, index4) in children.options" :key="index4"
                              :label="xuanziIndex[index4]">{{ xuanziIndex[index4] }}、{{ tab }}</el-radio>
                          </div>
                        </el-radio-group>
                      </el-form-item>
                    </div>
                    <div style="padding-left: 20px" v-if="children.subjectType === 'nChoice'"
                      :id="index + '_' + index2 + '_' + index3">
                      <div class="lke-text-in-span" style="font-weight: normal">
                        ({{ index3 + 1 }}).{{ children.subjectName }}
                      </div>
                      <el-form-item>
                        <el-checkbox-group v-model="children.answer">
                          <div class="lke-xuanze">
                            <el-checkbox v-for="(tab, index4) in children.options" :key="index4"
                              :label="xuanziIndex[index4]">{{ xuanziIndex[index4] }}、{{ tab }}</el-checkbox>
                          </div>
                        </el-checkbox-group>
                      </el-form-item>
                    </div>
                    <div style="padding-left: 20px" v-if="children.subjectType === 'trueOrFalse'"
                      :id="index + '_' + index2 + '_' + index3">
                      <div class="lke-text-in-span" style="font-weight: normal">
                        ({{ index3 + 1 }}).{{ children.subjectName }}
                      </div>
                      <el-form-item>
                        <el-radio-group v-model="children.answer[0]">
                          <div class="lke-xuanze">
                            <el-radio label="true">A、正确</el-radio>
                          </div>
                          <div class="lke-xuanze">
                            <el-radio label="false">B、错误</el-radio>
                          </div>
                        </el-radio-group>
                      </el-form-item>
                    </div>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
          <el-form style="padding-bottom: 40px; padding-top: 30px" v-if="paperInfo.name">
            <el-form-item>
              <div class="lke-buttom">
                <el-button :loading="loading" @click="savepaper()">保存</el-button>
                <el-button :loading="loading" @click="submit()" type="primary">提交</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getpaper, changepaper } from "@/api/index";
import { getToken, getImgUrl } from "@/utils/auth";
import moment from "moment";
export default {
  name: "examinationIndex",
  data() {
    return {
      isSave: true,
      loading: false,
      listLoading: false,
      minHeight: 1024,
      paperList: {},
      paperInfo: {},
      numIndex: [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二",
        "十三",
        "十四",
        "十五",
        "十六",
        "十七",
        "十八",
        "十九",
        "二十",
      ],
      xuanziIndex: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
      ],
      save: false,
      paperId: undefined,
      paperInfoId: undefined,
      courseId: undefined,
      courseClassId: undefined,
      exambatchId: undefined,
      clock: {},
      date: {
        h: "",
        m: "",
        s: "",
      },
      uploadAction: `${process.env.VUE_APP_BASE_API}/api/v1/file`,
      uploadHeaders: { Authorization: getToken() },
      fileBaseUrl: "",
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    roles() {
      return this.$store.state.roles;
    },
  },
  created() {
    this.minHeight = window.innerHeight;
    this.fileBaseUrl = getImgUrl() || "";
    this.paperId = this.GetQueryValue("paperId");
    this.courseId = this.GetQueryValue("courseId");
    this.courseClassId = this.GetQueryValue("courseClassId");
    this.exambatchId = this.GetQueryValue("exambatchId");
    this.paperInfoId = this.GetQueryValue("paperInfoId");
    this.getpaper();
  },
  mounted() {

    window.onbeforeunload = function (e) {
      e = e || window.event
      if (e) {
        e.returnValue = '网站可能不会保存您的修改哦~'
      }
      return '网站可能不会保存您的修改哦~'
    }

  },
  filters: {},
  watch: {},
  methods: {
    beforeDocUpload(file) {
      const fileName = file.name || "";
      const suffix = fileName.split(".").pop().toLowerCase();
      const supportTypes = ["doc", "docx", "pdf"];
      const isSupport = supportTypes.includes(suffix);
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isSupport) {
        this.$message.error("仅支持上传 Word/PDF 文件");
      }
      if (!isLt20M) {
        this.$message.error("文件大小不能超过 20MB");
      }
      return isSupport && isLt20M;
    },
    handleShortAnswerUploadSuccess(res, file, paper) {
      const patch = res && res.patch ? res.patch : "";
      if (!patch) {
        this.$message.error("附件上传失败，请重试");
        return;
      }
      this.$set(paper.coursesubject, "answer", [patch]);
      this.$message.success("附件上传成功，已填入答案");
    },
    isFileLink(value) {
      if (!value) {
        return false;
      }
      const text = String(value).trim();
      return /\.(doc|docx|pdf)$/i.test(text) || /^https?:\/\//i.test(text);
    },
    extractFileName(value) {
      if (!value) {
        return "";
      }
      const raw = String(value).split("?")[0];
      const parts = raw.split("/");
      return parts[parts.length - 1] || raw;
    },
    toFileUrl(value) {
      const text = String(value || "");
      if (/^https?:\/\//i.test(text)) {
        return text;
      }
      return `${this.fileBaseUrl}${text}`;
    },
    getpaper() {
      this.listLoading = true;
      let obj = {};
      if (this.courseId) {
        obj.courseId = this.courseId;
      }
      if (this.courseClassId) {
        obj.courseClassId = this.courseClassId;
      }
      if (this.exambatchId) {
        obj.exambatchId = this.exambatchId;
      }
      if (this.paperInfoId) {
        obj.paperInfoId = this.paperInfoId;
      }
      getpaper(this.paperId, obj)
        .then((response) => {

          this.countTime(response.createdAt, response.time);
          this.paperInfo = {
            name: response.name,
            time: response.time,
            _id: response._id,
          };
          if (response.paperAnswerStu) {
            this.paperList = response.paperAnswerStu;
            this.paperInfo.state = true;
          } else {
            this.paperList = response.paperInfo;
            this.paperInfo.state = false;
          }
          this.listLoading = false;
        })
        .catch((response) => {
          this.listLoading = false;
        });
    },

    savepaper() {
      if (!this.isSave) {
        this.$message({
          message: '请勿5秒之内连续保存',
          type: 'warning'
        });
        return
      }
      this.isSave = false
      setTimeout(() => {
        this.isSave = true
      }, 5000);
      this.loading = true;
      let obj = {
        paperAnswerStu: JSON.stringify(this.paperList),
      };
      changepaper(this.paperInfo._id, obj)
        .then((response) => {
          this.paperInfo = {
            name: response.name,
            time: response.time,
            _id: response._id,
            state: true,
          };
          this.paperList = response.paperAnswerStu;
          this.$notify({
            title: "保存成功",
            message: "试卷保存成功，保存成功后可以提交！",
            type: "success",
            duration: 0,
          });
          this.loading = false;
        })
        .catch((response) => {
          this.loading = false;
        });
    },

    submit() {
      if (this.paperInfo.state) {
        this.loading = true;
        this.$confirm(
          "提交试卷后将不可继续答题，提交内容为最后一次保存的内容",
          "提交警告",
          {
            confirmButtonText: "提交",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            let obj = {
              paperState: 1,
              paperAnswerStu: JSON.stringify(this.paperList),
            };
            changepaper(this.paperInfo._id, obj).then((response) => {

              this.$notify({
                title: "提交成功",
                message: "",
                type: "success",
                duration: 0,
              });
              window.clearInterval(this.clock);
              this.$router.push({
                name: "examinationResults",
                params: {
                  id: this.paperInfo.name,
                },
                query: {
                  state: response.pass,
                  scoreSum: response.scoreSum,
                },
              });
            });
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.$notify({
          title: "提交失败",
          message: "请保存试卷后提交",
          type: "warning",
          duration: 0,
        });
      }
    },

    GetQueryValue(queryName) {
      let query = window.location.href.split("?")[1];
      let vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == queryName) {
          return pair[1];
        }
      }
      return null;
    },

    countTime(val, val2) {
      let outtime = new Date(val);
      outtime = outtime.setMinutes(outtime.getMinutes() + val2);
      let date = +new Date();
      let timBegin = outtime;
      let time = Math.floor(~~(timBegin - date) / 1000);
      this.clock = window.setInterval(() => {
        this.date.h = Math.floor((time / 60 / 60) % 24);
        this.date.m = Math.floor((time / 60) % 60);
        this.date.s = Math.floor(time % 60);
        time = time - 1;
        if (time < 0) {
          window.clearInterval(this.clock);
          let obj = {
            paperState: 1,
            paperAnswerStu: JSON.stringify(this.paperList),
          };
          changepaper(this.paperInfo._id, obj).then((response) => {

            this.$notify({
              title: "提交成功",
              message: "",
              type: "success",
              duration: 0,
            });

            window.clearInterval(this.clock);
            this.$router.push({
              name: "examinationResults",
              params: {
                id: this.paperInfo.name,
              },
              query: {
                state: response.pass,
                scoreSum: response.scoreSum,
              },
            });
          });
        }
      }, 1000);
    },

    gopaper(val) {
      document.getElementById(val).scrollIntoView();
    },
  },
};
</script>

<style>
.el-checkbox,
.el-checkbox__input {
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 18px;
  vertical-align: middle;
  display: inline;
}

.el-radio__label {
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 18px;
  vertical-align: middle;
  display: inline;
}
</style>

<style scoped>
::v-deep.lke-text .el-input {
  width: 300px;
}

::v-deep.el-radio {
  display: block;
  margin-right: 0;
  margin-bottom: 15px;
  margin-left: 15px;
}

::v-deep.el-checkbox {
  display: block;
  margin-right: 0;
  margin-left: 15px;
}

::v-deep.el-form-item {
  margin-bottom: 0;
}

.lke-bg {
  width: 1024px;
  background: #fff;
  padding: 0 30px 0 25px;
  margin: 0 auto;
  /* display: flex;
  align-items: flex-start; */
}

.lke-bg-l {
  width: 250px;
  padding-top: 10px;
  padding-left: 5px;
  padding-right: 10px;
  flex-shrink: 0;
  position: fixed;
  top: 0;
  z-index: 800;
  max-height: 100%;
  overflow-y: auto;
}

.lke-bg-l::-webkit-scrollbar {
  display: none;
  /* background-color:transparent; */
}

.lke-bg-r {
  padding-top: 10px;
  margin-left: 265px;
  width: 759px;
}

.lke-box {
  border: 1px solid #fff;
  border-radius: 5px;
  box-shadow: 0 0px 5px rgba(0, 0, 0, 0.3);
  padding: 10px 15px;
  margin-bottom: 10px;
}

.lke-l-t {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.lke-l-t>div {
  margin-top: 5px;
  font-size: 12px;
  letter-spacing: 1px;
}

.lke-l-t>div:first-child {
  margin: 0;
  font-size: 16px;
  letter-spacing: 1px;
  padding-bottom: 5px;
}

.lke-l-m {
  font-size: 14px;
  text-align: center;
}

.lke-l-m>span {
  color: red;
}

.lke-l-f-title {
  font-size: 16px;
  letter-spacing: 1px;
  text-align: center;
  margin-bottom: 10px;
}

.lke-l-f-box {
  padding-bottom: 4px;
}

.lke-l-f-box-top {
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: 600;
  padding-left: 5px;
  margin-bottom: 10px;
}

.lke-l-f-box-mid {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.lke-l-f-box-mid-tab-on {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.lke-l-f-box-mid-tab-on>div:first-child {
  padding: 0 10px 0 10px;
  line-height: 34px;
}

.lke-l-f-box-mid-tab {
  width: calc(100% / 6);
  margin-bottom: 5px;
}

.lke-l-f-box-mid-tab-in {
  margin-right: 5px;
  height: 32px;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0px 5px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.lke-l-f-box-mid-tab-in.active {
  background: #409eff;
}

.lke-r-t {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.lke-r-t>span:first-child {
  font-size: 18px;
  letter-spacing: 2px;
  padding-bottom: 2px;
  font-weight: 600;
}

.lke-r-t>span:last-child {
  color: #aaacaa;
  letter-spacing: 1px;
  font-size: 14px;
}

.lke-r-title {
  padding: 15px;
  color: #2890f4;
  letter-spacing: 1px;
  border-bottom: 2px solid #2890f4;
  margin-bottom: 15px;
}

.lke-buttom {
  display: flex;
  justify-content: center;
}

.lke-text {
  padding-bottom: 10px;
}

.lke-text-in-span {
  width: 95%;
  padding: 10px 0 15px 10px;
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 18px;
  vertical-align: middle;
  display: inline-block;
}

.lke-text-in-span>span {
  color: #cbcbcb;
  margin-left: 15px;
}

.lke-xuanze {
  padding: 10px;
}

.short-answer-upload-tip {
  margin-top: 8px;
  color: #666;
}
</style>
<style>
.el-checkbox__label {
  white-space: normal;
  /* 允许自动换行 */
  word-break: break-word;
  /* 在长单词处进行断行 */
  max-width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/examination/examinationIndex.vue